import React from 'react';
import Field from './Field'

export default class FieldCheckboxSelect extends Field {
    constructor(props) {
        super(props)

        this.state = {
            selectedOptions: Array.isArray(props.value) ? props.value : []
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let value = [];
        if (nextProps.value) {
            value = nextProps.value.toJS();
        }

        this.setState({
            selectedOptions: value
        })
    }

    onOptionChange = item => {
        let selectedOptions = this.state.selectedOptions
        if (selectedOptions.includes(item.value)) {
            selectedOptions.splice(selectedOptions.indexOf(item.value), 1)
        } else {
            selectedOptions.push(item.value)
        }

        this.setState({
            selectedOptions: selectedOptions
        })

        if (this.props.onChange) {
            this.props.onChange(selectedOptions)
        }
    }

    isOptionChecked = value => {
        return this.state.selectedOptions.includes(value)
    }

    renderField() {
        var className = ['configuration-radiogroup'];
        if (this.props.partitionSize)
            className.push('partition')

        return (
            <div className={className.join(' ')}>
                {this.renderFieldInternal()}
            </div>
        )
    }

    renderFieldInternal() {
        var items = this.props.items;
        if (this.props.partitionSize) {
            return this.renderByPart();
        }

        return (
            items.map(item => this.renderItem(item))
        )
    }

    renderByPart() {
        var items = this.props.items;
        var parts = items.grouping(2);
        return (
            parts.map((part, idx) => (
                <div key={idx} className="configuration-radiogroup-part">
                    {part.map(item => this.renderItem(item))}
                </div>
            ))
        )
    }

    renderItem(item) {
        let itemId = this.generateUniqueId()

        return (
            <div key={item.value} className="configuration-radiogroup-item">
                <input id={itemId} type="checkbox" checked={this.isOptionChecked(item.value)}
                       onChange={e => this.onOptionChange(item)}/>
                <label tabIndex="0" htmlFor={itemId}>{__(item.text)}</label>
            </div>
        )
    }
}